import { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { colorLabel } from '@atlas-frontend/design-tokens';
import { RequiredText } from '../components';

export interface FormLabelProps extends HTMLAttributes<HTMLLabelElement> {
  htmlFor?: string;
  required?: boolean;
  hidden?: boolean;
}

export const FormLabel: FC<FormLabelProps> = (props) => {
  const { htmlFor, required, hidden, children, ...rest } = props;

  const labelElement = (
    <StyledLabel htmlFor={htmlFor} {...rest}>
      <RequiredText required={!!required}>{children}</RequiredText>
    </StyledLabel>
  );

  if (hidden) {
    return <HiddenLabelWrapper>{labelElement}</HiddenLabelWrapper>;
  }

  return labelElement;
};

const HiddenLabelWrapper = styled.div`
  height: 0;
  overflow: hidden;
`;

const StyledLabel = styled.label`
  color: ${colorLabel};
`;
